import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {WalletTransactionModel} from '@/libs/Api';
import {WalletTransactionsDataService} from '@/libs/wallet-transactions/wallet-transactions-data-service';
import {StoreName} from '@/libs/core/store/store-name';

export const walletTransactionsStore = registerCrudStore<WalletTransactionModel, WalletTransactionModel>(StoreName.WalletTransaction, new WalletTransactionsDataService());
